import { Component, Inject, forwardRef, OnInit, PLATFORM_ID } from '@angular/core';
import { NgAisInstantSearch } from 'angular-instantsearch';
import { connectRefinementList } from 'instantsearch.js/es/connectors';
import { CatalogWidgetDirective, IBaseItem } from '../catalog-widget';
import { parseItemLabelAndId, checkRouteParameters } from '@app/shared/components/catalog/services/filters.service';

interface IFilterColor {
  id: number;
  type: 'united' | 'bordered' | 'image' | 'unset';
  hexadecimal?: string;
  gradient?: string;
  border?: string;
  image?: string;
}

@Component({
  selector: 'vc-catalog-widget-colors',
  templateUrl: './catalog-widget-colors.component.html',
  styleUrls: ['../catalog-widgets.scss', './catalog-widget-colors.component.scss']
})
export class CatalogWidgetColorsComponent extends CatalogWidgetDirective implements OnInit {
  public colorsMap: IFilterColor[] = [
    {
      id: 53,
      type: 'united',
      hexadecimal: '#4E4E4E'
    },
    {
      id: 15,
      type: 'image',
      hexadecimal: 'transparent',
      image: '/assets/img/filters/colors/silver.png'
    },
    {
      id: 2,
      type: 'united',
      hexadecimal: '#DFC4A3'
    },
    {
      id: 1,
      type: 'bordered',
      hexadecimal: '#FFF',
      border: '#EAEAEA'
    },
    {
      id: 9,
      type: 'united',
      hexadecimal: '#68A0F2'
    },
    {
      id: 220,
      type: 'united',
      hexadecimal: '#A04551'
    },
    {
      id: 222,
      type: 'united',
      hexadecimal: '#C6975A'
    },
    {
      id: 16,
      type: 'image',
      hexadecimal: 'transparent',
      image: '/assets/img/filters/colors/gold.png'
    },
    {
      id: 219,
      type: 'united',
      hexadecimal: '#F8F9EC'
    },
    {
      id: 13,
      type: 'united',
      hexadecimal: '#C5C5C5'
    },
    {
      id: 3,
      type: 'united',
      hexadecimal: '#FAEC67'
    },
    {
      id: 12,
      type: 'united',
      hexadecimal: '#97A463'
    },
    {
      id: 224,
      type: 'united',
      hexadecimal: '#325B8C'
    },
    {
      id: 8,
      type: 'united',
      hexadecimal: '#A57738'
    },
    {
      id: 221,
      type: 'image',
      hexadecimal: 'transparent',
      image: '/assets/img/filters/colors/metallic.png'
    },
    {
      id: 17,
      type: 'image',
      hexadecimal: 'transparent',
      image: '/assets/img/filters/colors/multicolor.png'
    },
    {
      id: 14,
      type: 'united',
      hexadecimal: '#000000'
    },
    {
      id: 4,
      type: 'united',
      hexadecimal: '#FFB449'
    },
    {
      id: 5,
      type: 'united',
      hexadecimal: '#FDC0D7'
    },
    {
      id: 6,
      type: 'united',
      hexadecimal: '#DD5252'
    },
    {
      id: 225,
      type: 'united',
      hexadecimal: '#8DE4DD'
    },
    {
      id: 11,
      type: 'united',
      hexadecimal: '#89B379'
    },
    {
      id: 7,
      type: 'united',
      hexadecimal: '#BF55BD'
    },
    {
      id: 21,
      type: 'unset'
    }
  ];

  state: {
    items: IBaseItem[];
    createURL: () => string;
    refine: (value: string) => void;
    searchForItems: (value: string) => void;
    isFormSearch: boolean;
    canRefine: boolean;
    widgetParams: {};
    canToggleShowMore: boolean;
    isShowingMore: boolean;
    toggleShowMore: () => void;
  };

  constructor(
    @Inject(forwardRef(() => NgAisInstantSearch)) public instantSearchParent,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    super('CatalogWidgetColorsComponent', platformId);
  }

  ngOnInit() {
    this.createWidget(connectRefinementList, {
      limit: this.options.limit,
      attributeName: this.options.facet,
      sortBy: ['name:asc']
    });
    super.ngOnInit();
  }

  get items() {
    const transformedItems = [];
    const filterUrlList = this.getUrlList();
    for (const item of this.state.items || []) {
      const newItem = { ...item, ...parseItemLabelAndId(String(item.label), false, null, filterUrlList) };
      if (super.isSeoUrlHidden(parseInt(newItem.count, 10))) {
        newItem.url = null;
      }

      const settings = { settings: this.getColorSettings(newItem.id) };
      if (checkRouteParameters(this.options.routeParameters, this.pageRouteParameter, newItem)) {
        transformedItems.push({ ...item, ...newItem, ...settings });
      }
    }

    return transformedItems;
  }

  getColorSettings(colorId): IFilterColor {
    return this.colorsMap.find(item => item['id'] === colorId);
  }
}
